import StackdriverErrorReporter from 'stackdriver-errors-js';

const GOOGLE_WEB_API_KEY = process.env.GOOGLE_WEB_API_KEY;
const GOOGLE_PROJECT_ID = process.env.GOOGLE_PROJECT_ID;

let errorHandler;

if (process.env.NODE_ENV === 'production' && GOOGLE_WEB_API_KEY && GOOGLE_PROJECT_ID) {
       errorHandler = new StackdriverErrorReporter();
       errorHandler.start({
              key: process.env.GOOGLE_WEB_API_KEY,
              projectId: process.env.GOOGLE_PROJECT_ID,
              service: 'AlanStudio',
              version: process.env.VERSION,
       });
} else {
       errorHandler = { report: () => { } };
}

export default errorHandler;